import Checkbox from "components/Checkbox";
import { IInputFieldWithValidationProps } from "components/InputFieldWithValidation";
import { PaymentSourceInputName } from "v2/dataroutes/BillingData";


export default function PrimaryCardCheckbox(
  {
    ...props
  }: Omit<IInputFieldWithValidationProps, "type" | "label">
) {
  return (
    <Checkbox
      { ...props }
      label="Make this my default payment method"
      name={ props.name ?? PaymentSourceInputName.primary }
    />
  );
};
